import { BACKEND_URL } from './settings'

export const absUrl = (url: string): string => {
  if (!url.match(/^https?:\/\//)) {
    return BACKEND_URL + url
  }
  return url
}
